module.exports = __webpack_public_path__ + "static/media/shopify16.e40a3562.png";